import axios from 'axios';
import env from '../env';
import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';
import { InfoAllByWabaId } from '../types/InfoAllByWabaId';

const getInfoAllByWabaId = async (
  waba_id: string,
  requestFromWabaService: boolean,
  userAccessToken?: string
): Promise<InfoAllByWabaId | undefined> => {
  try {
    var response;
    if(requestFromWabaService){
      const url = `/waba/info/${waba_id}`;
      response = await poliApiGatewayRequest.get(url);
    } else {
      // Use userAccessToken if provided (for coexistence flow), otherwise use system token
      const accessToken = userAccessToken || env.SYSTEM_USER_ACCESS_TOKEN;
      // Request phone_numbers with nested fields to get complete phone data
      response = await axios.get(
        `https://graph.facebook.com/v14.0/${waba_id}?fields=on_behalf_of_business_info,id,name,message_template_namespace,phone_numbers{id,display_phone_number,verified_name,code_verification_status,quality_rating}&access_token=${accessToken}`
      );
    }

    console.log(`getInfoAllByWabaId: Successfully retrieved info for WABA ${waba_id}`, response.data);

    const data: InfoAllByWabaId | undefined = response?.data;
    if (!data) {
      console.error(`getInfoAllByWabaId: No data returned for WABA ID ${waba_id}`);
      return undefined;
    }

    return data;
  } catch (error: any) {
    const axiosError = error;

    if (axiosError.response) {
      const status = axiosError.response.status;
      const errorData: any = axiosError.response.data;

      console.error(
        `getInfoAllByWabaId: API Error (${status}) for WABA ${waba_id}:`,
        errorData?.error?.message || errorData?.message || 'Unknown error'
      );

      // Log specific error scenarios
      if (status === 403) {
        console.error(
          'Access denied to WABA. User may not have admin permissions '
          + 'or the account may not be accessible with current credentials.'
        );
      } else if (status === 404) {
        console.error(
          `WABA ID ${waba_id} not found. It may have been deleted or ID is incorrect.`
        );
      } else if (errorData?.error?.code === 100) {
        console.error(
          'OAuth Error #100: Invalid access token. '
          + 'Check if SYSTEM_USER_ACCESS_TOKEN is properly configured.'
        );
      } else if (status == 400) {
        console.error(error);
        return undefined;
      }
    } else if (axiosError.request) {
      console.error(
        `getInfoAllByWabaId: No response received from server for WABA ${waba_id}`
      );
    } else {
      console.error(
        `getInfoAllByWabaId: Error setting up request for WABA ${waba_id}:`,
        axiosError.message
      );
    }

    // Re-throw to allow upper layers to handle
    throw error;
  }
};

export { getInfoAllByWabaId };
